<template lang="html">
  <div id="informationPopup" v-if="$store.state.isInfoPopupShown">
    <span>予約の情報</span>
    <table id="tableTimes">
      <tr>
        <td><span>開始: </span></td>
        <td>{{ $store.state.informationPopup.reservation.start_time }}
        </td>
      </tr>
      <tr>
        <td><span>終了: </span></td>
        <td>{{$store.state.informationPopup.reservation.end_time  }}
        </td>
      </tr>
    </table>
    <label v-if="isTanki()">短期講座</label>

    <table id="tableNames">
      <tr>
        <td><span>生徒のお名前：</span></td>
        <td>{{ $store.state.informationPopup.reservation.student.fullname }}</td>
      </tr>
      <tr>
        <td><span>先生のお名前：</span></td>
        <td>{{ $store.state.informationPopup.reservation.teacher.fullname }}</td>
      </tr>
    </table>
    <div>
      <div id="reservationType">授業の種類: {{ $store.state.informationPopup.reservation.reservation_type }}</div>
      <div id="hasTest">
        配布物: {{ $store.state.informationPopup.reservation.has_test ? '有り' : '無し'}}
      </div>
    </div>
    <div id="messageContainer">
      <div id="messageSubject">連絡事項</div>
      <div class="reservationMessage" v-if="$store.state.informationPopup.reservation.message">
        {{ $store.state.informationPopup.reservation.message }}
      </div>
      <div class="reservationMessage" v-else>
        なし
      </div>
    </div>
    <div id="isOnline">
        授業形態: {{Number($store.state.informationPopup.reservation.online)===1 ? 'オンライン' : '対面'}}
      </div>
    <button v-if="isEditable()" @click="enterEdit">編集する</button><br>
    <button  @click="enterRescheduling">振替を依頼する</button><br>
    <button @click="closePopup">閉じる</button>
  </div>
</template>

<script>
import {
  mapGetters,
  mapActions
} from 'vuex'
import {
  HIDE_INFORMATION_POPUP,
  RESERVATIONBOX_ENTER_EDIT,
  SPINNER_HIDE,
  SPINNER_SHOW,
  RESERVATIONBOX_ENTER_RESCHEDULING
} from '@/vuex/mutation_types'
export default {
  data () {
    return {
      width: 400,
      isAllEditing: false,
      dialogDeleteVisible: false
    }
  },
  computed: {
    ...mapGetters([
      'getLeftPosOfClassroom',
      'timelinesWidth',
      'timelineHeight',
      'timeToPosition',
      'getCurDateFormated'
    ])
  },
  methods: {
    ...mapActions([
      'deleteReservation',
      'deleteRecurrentReservations',
      'getReservations'
    ]),
    isTanki () {
      let st = this.$store.state.informationPopup.reservation.student.status
      return st === 'temporal' || st === 'trial' || st === 'temp/temp' || st === 'temp/norm'
      // return this.$store.state.informationPopup.reservation.student.user_name.startsWith('tanki')
    },
    closePopup () {
      this.$store.commit(HIDE_INFORMATION_POPUP)
    },
    enterEdit () {
      this.$store.commit(HIDE_INFORMATION_POPUP)
      this.$store.commit(RESERVATIONBOX_ENTER_EDIT,
          this.$store.state.informationPopup.reservation)
    },
    enterRescheduling () {
      this.$store.commit(HIDE_INFORMATION_POPUP)
      this.$store.commit(RESERVATIONBOX_ENTER_RESCHEDULING,
          this.$store.state.informationPopup.reservation)
    },
    enterDelete () {
      this.eraseReservation()
    },
    doDelete () {
      this.$store.commit(SPINNER_SHOW)
      let recurrenceId = this.$store.state.informationPopup.reservation.recurrence_id
      if (!this.isAllEditing) {
        // 1つの予約のみ削除
        this.deleteReservation(this.$store.state.informationPopup.reservation.id)
        .then(() => {
          // 予約情報を更新
          this.getReservations({
            date: this.getCurDateFormated,
            school_id: this.$store.state.userInfo.school_id
          })
        })
        this.closePopup()
        this.$store.commit(SPINNER_HIDE)
      } else {
        // 以降の予約を全て削除
        this.deleteRecurrentReservations({ id: recurrenceId, fromReservaitonId: this.$store.state.informationPopup.reservation.id })
        .then(() => {
          // 予約情報を更新
          this.getReservations({
            date: this.getCurDateFormated,
            school_id: this.$store.state.userInfo.school_id
          })
        })
        this.closePopup()
        this.$store.commit(SPINNER_HIDE)
      }
      this.$store.commit(HIDE_INFORMATION_POPUP)
    },
    eraseReservation () {
      if (this.$store.state.informationPopup.reservation.recurrence_id !== null) {
        // 繰り返し予約の削除の場合は確認ダイアログを出す
        this.dialogDeleteVisible = true
      } else {
        let ret = confirm('削除します．よろしいですか？')
        if (ret) {
          this.doDelete()
        }
      }
    },
    isEditable () {
      let userType = this.$store.state.userInfo.user_type
      return userType !== 'student' &&
              (userType === 'admin' ||
              this.$store.state.informationPopup.reservation.teacher.id === this.$store.state.userInfo.user_id
            ) &&
            this.isFuture() &&
            this.isBeforeDeadline()
    },
    isFuture () {
      // 現在時刻が予約時刻よりも前かどうか
      let today = new Date()
      let date = this.$store.state.informationPopup.reservation.date.split(' ')[0].split('-').map((x) => parseInt(x))
      let startTime = this.$store.state.informationPopup.reservation.start_time.split(' ')[0].split(':').map((x) => parseInt(x))
      let reservationDate = new Date(date[0], date[1] - 1, date[2], startTime[0], startTime[1])
      return today.getTime() < reservationDate.getTime() || this.$store.state.userInfo.user_type === 'admin'
    },
    isBeforeDeadline () {
      // 現在時刻が予約時刻の1日前(予約時刻が月曜日の場合は2日前)の22時以前かどうか
      // 管理者にはこの制限を設けない
      if (this.$store.state.userInfo.user_type === 'admin') {
        return true
      }
      let today = new Date()
      let date = this.$store.state.informationPopup.reservation.date.split(' ')[0].split('-').map((x) => parseInt(x))
      let startTime = this.$store.state.informationPopup.reservation.start_time.split(' ')[0].split(':').map((x) => parseInt(x))
      let reservationDate = new Date(date[0], date[1] - 1, date[2], startTime[0], startTime[1])

      let dateDiff = (new Date(reservationDate.getFullYear(), reservationDate.getMonth(), reservationDate.getDate()) -
                        new Date(today.getFullYear(), today.getMonth(), today.getDate())) / 1000 / 60 / 60 / 24
      return (reservationDate.getDay() === 1 && (dateDiff > 2 || (dateDiff === 2 && today.getHours() < 22))) ||   // 予約時刻が月曜日の場合
              (reservationDate.getDay() !== 1 && (dateDiff > 1 || (dateDiff === 1 && today.getHours() < 22)))     // 月曜日以外の場合
    }
  }
}
</script>

<style lang="css" scoped>
#informationPopup {
  position: absolute;
  top: 81px;
  width: 100%;
  height: 90vh;
  left: -5px;
  right: 0;
  font-size: 5vw;
  margin: 0px 5px 0px;
  box-sizing: border-box;
  background-color: white;
  border-color: #0065B3;
  border-style: solid;
  border-radius: 5px;
  padding-top: 5px;
  z-index: 1999;
}
#tableTimes, #tableNames {
  margin: 10px;
}

#reservationType,#hasTest {
  display: inline;
  width: 150px;
  margin: 10px;
}
#messageBody {
  width: 90%;
}
#reservationType>input {
  width:80px;
}
#delete-block {
  color: #ff6666;
}
#delete-block > button {
  color: #ff6666;
}
Button {
  margin: 10px;
  border-radius: 5px;
  font-size: 7vw;
}
label {
  display: block;
}


#messageContainer {
  width:100%;
  margin-top: 10px;
}
.dialog {
  text-align: left;
}
.reservationMessage{
  width: 60%;
  margin: auto;
  border: solid 2px rgb(105, 104, 88);
}
</style>



// WEBPACK FOOTER //
// SpInformationPopup.vue?2e1b2208